import * as React from "react"
import { Badge,  Flex, Link, Stack, Text } from "@chakra-ui/react"

import { AgendaItemFragment, useGetActQuery } from "lib/graphql"
import { transformImage } from "lib/helpers/utils"
import { LinkButton } from './LinkButton'

interface ItemProps {
  item: AgendaItemFragment
}

export const AgendaItem: React.FC<ItemProps> = ({ item }) => {
  // get act from item
  const { data: actData, loading: actLoading } = useGetActQuery({ variables: { id: item.id }, skip: !!!item.id })
  const act = actData?.act

  return (
    <Stack position="relative" mt={0}>
      <Stack spacing={2} >
        <Link
          href={item.type === "competition" ? `/wedstrijd/${item.slug}` : `/te-doen/${item.slug}`}
          w="100%"
          textDecoration="none"
          display="flex"
          flexDir="column"
          alignItems="flex-start"
          _hover={{ textDecoration: "none" }}
          position="relative"
          >
          <Flex
            borderRadius="xl"
            height="220px"
            w="100%"
            bgImage={item?.image ? transformImage(item?.image, "h_850") : "event-placeholder.png"}
            bgSize="cover"
            bgPos="center"
            role="img"
            aria-label={item.type === "competition" ? "wedstrijd image" : "agenda image"}
            pos="relative"
            filter="brightness(60%)"
            p={2}
            alignItems="flex-end"
            />

          <Badge
            position="absolute"
            bg="yellow.500"
            color="black"
            // bg="transparent"
            // borderColor="yellow.500"
            // borderWidth="1px"
            // borderRadius="md"
            top={2}
            right={2}
            textTransform="capitalize"
            fontSize="md"
            px={2}
            >
            {item.type === "competition" ? "wedstrijd" : "agenda"}
          </Badge>
          <Flex 
            direction="column" 
            position="absolute"
            bottom={2}
            left={2}
            w="100%"
            pr={4}
          >
            <Text
              color="white"
              fontSize={{ base: "md", md: "2xl" }}
              fontWeight="bold"
              maxW="60%"
              noOfLines={2}
              >
              {item.name}
            </Text>
            {item.type === "competition" && act?.completedPercent !== 100 && (
              <LinkButton w="100%" mt={1} variant="solid" size="sm" colorScheme='yellow' href={`/acts/${item.id}`}>
                Act voltooiing: {act?.completedPercent}% - Maak je act af
              </LinkButton>
            )}
          </Flex>
        </Link>
      </Stack>
      
    </Stack>
  )
}
